import { Spinner } from "flowbite-react";

export default function LoadingPage() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <Spinner size="xl" />
    </div>
  );
}
